<template>
<div class="download">
    <h1>Download Now</h1>
    <h3 v-if="isExisted" class="default-header-three">It looks like you already have an account.</h3>
    <h3 class="default-header-three">Hit 'Download' and start exploring DataMapper.</h3>
    <div class="buttons">
        <button class="simple" @click="download(links.mac)" :class="{current: isMac || isLinux}">
            <i class="icon-apple"></i> Download for Mac</button>
        <button class="simple"  @click="download(links.win)" :class="{current: isWin || isLinux}">
            <i class="icon-windows"></i> Download for Windows</button>
    </div>
    <img src="~@/assets/img/safe-online-logo.jpg" alt="DataMapper logo" />
</div>
</template>

<script>
export default {
    data () {
        return {
            os: window.navigator.platform,
            links: {}
        }
    },
    created () {
        this.links = this.$Config.downloadLinks
    },
    computed: {
        isMac() { return this.os == 'MacIntel'},
        isWin () { return /Win/.test(this.os) },
        isLinux () { return /Linux/.test(this.os) },
        isExisted() { return this.$route.query.exists && JSON.parse(this.$route.query.exists) }
    },
    methods: {
        download (link) {
            window.location.href = link
        }
    }
}
</script>

<style lang="scss">
.download {

    margin-top: 35px;

    h1 {
        font-size: 28px;
    }

    h3 {
        font-size: 20px;
    }
}

</style>



// WEBPACK FOOTER //
// apps/account/Download.vue